import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import { OrganizationCustomFieldsService } from 'src/app/core/api/services/organization-custom-fields.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'custom-field-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class CustomFieldSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  constructor(protected currentService: OrganizationCustomFieldsService) {
    super();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';

    if (!this.label) this.label = 'common.customFields';
  }

  getItemsApi() {
    this.currentService
      .organizationCustomFieldsGetOrganizationCustomFieldsWithPagination({
        body: { pageSize: 100, pageNumber: 1 },
      })
      .pipe(
        this.basePipeOperators(),
        map((items) => {
          return items.data.items.map((item) => {
            return {
              ...item,
              optionTitle: `${item.nameFa} (${item.nameEn})`,
            };
          });
        })
      )
      .subscribe(this.baseObserver);
  }
}
